/* eslint-disable no-unused-vars */
import { apolloClient } from '@/setup/apollo-setup'
import { supportState, endSupport } from '@/utils/student-support-session'

import {
  SIGN_IN,
  RESET_KEY,
  SIGN_OUT,
  OTP_RESET,
  GET_CURRENT_USER,
  GET_NAVE_MENU_ITEM,
  GET_PERMISSIONS,
  FORGOT_PASSWORD,
  UPDATE_INFORMATION
} from '@/queries/core'

import {
  serverResponseStatus,
  // serverResponseStatusCustom,
  // info,
  // warning,
  error,
  addItemSuccess,
  // updateItemSuccess,
  // deleteItemSuccess,
  } from '@/utils/notification'

export function setLanguage ({ commit }, payload) {
  if (process.env.NODE_ENV === 'development') {
    console.log('$store/setLanguage', payload) // eslint-disable-line no-console
  }
  commit('changeLanguage', payload)
}

// export async function initializeData (context) {

//   const version = process.env.VUE_APP_PACKAGE_VERSION
//   console.log(`Application Version ${version}`) // eslint-disable-line no-console
//   console.log('Initializing Data...') // eslint-disable-line no-console

//   context.commit('clearError')
//   context.commit('setProcessing', true)
//   try {
//     await context.dispatch('Accounting/getContractsByCurrentUser')
//     context.commit('setSuccess', null)
//   } catch (e) {
//     console.log(e); // eslint-disable-line no-console
//     context.commit('setError', null)
//   }
// }

export async function getNavMenuItems ({ commit }) {
  // console.log('Get NavMenuItems...')

  commit('clearError')
  commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_NAVE_MENU_ITEM,
        fetchPolicy: 'network-only'
      })

    const { data } = await response

    commit('setNavMenuItems', data.getNaveMenuItem)
    commit('setSuccess', null)

  } catch (e) {
    console.log(e); // eslint-disable-line no-console
    commit('setError', null)
  }
}

export async function getPermissions ({ commit }) {
  // console.log('Get Permissions...')

  commit('clearError')
  commit('setProcessing', true)
  try {
    const response = await apolloClient
      .query({
        query: GET_PERMISSIONS,
        fetchPolicy: 'network-only'
      })

    const { data } = await response

    commit('setPermissions', data.getPermissions)
    commit('setSuccess', null)

  } catch (e) {
    console.log(e); // eslint-disable-line no-console
    commit('setError', null)
  }
}

export async function signIn (context, payload) {
  //console.log('SignIn...') // eslint-disable-line no-console
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {...payload.credential}

    const response = await apolloClient
      .mutate({
        mutation: SIGN_IN,
        variables,
        fetchPolicy: 'no-cache'
      })

    const { data } = await response;
    const { signIn } = await data;
    const { token, user } = await signIn;

    await context.commit('setToken',  token)
    await context.commit('setCurrentUser', user)
    await context.dispatch('Accounting/getContractsByCurrentUser')
    context.commit('setSuccess', serverResponseStatus('notification.authentication-success-title', {
      status: {success: true, error: false, message: 'notification.authentication-success-message'}
    }))

    setTimeout(() => {
      if(data.signIn.user.oneTimePasswordReset) payload.vm.$router.push("/")
      else                                      payload.vm.$router.push("/user/reset-password")
    }, 200);
  } catch (e) {
    console.log(e) // eslint-disable-line no-console
    context.commit('setError', serverResponseStatus('notification.authentication-error-title', {
      status: {success: false, error: true, message: 'notification.authentication-error-message'}
    }))
  }
}

export async function resetKey (context, payload) {
  //console.log('SignIn...') // eslint-disable-line no-console
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {...payload.credential}

    const response = await apolloClient
      .mutate({
        mutation: RESET_KEY,
        variables,
        fetchPolicy: 'no-cache'
      })

    const { data } = await response


    await context.commit('setToken',  data.resetKey.token)
    await context.commit('setCurrentUser', data.resetKey.user)
    await context.dispatch('Accounting/getContractsByCurrentUser')
    context.commit('setSuccess', serverResponseStatus('notification.authentication-success-title', {
      status: {success: true, error: false, message: 'notification.authentication-success-message'}
    }))

    setTimeout(() => {
      payload.vm.$router.push("/user/reset-password")
    }, 200);
  } catch (e) {
    console.log(e) // eslint-disable-line no-console
    context.commit('setError', serverResponseStatus('notification.authentication-error-title', {
      status: {success: false, error: true, message: 'notification.authentication-error-message'}
    }))
    setTimeout(() => {
      payload.vm.$router.push("/pages/page-error-404")
    }, 200);
  }
}

export async function signOut (context, vm) {
  if (supportState.mode) { endSupport('ออกจากโหมดผู้ดูแลแล้ว สามารถปิดแท็บนี้ได้'); return }
  // console.log('Signing Out...') // eslint-disable-line no-console

  context.commit('clearError')
  context.commit('setProcessing', true)
  let signOutRequest = null
  try {
    // Start server-side refresh-token revocation while the access token is still available.
    signOutRequest = apolloClient.mutate({ mutation: SIGN_OUT })
  } catch (e) {
    console.log(e) // eslint-disable-line no-console
  }

  // A network, Backend or LoginLog failure must never keep this browser signed in.
  context.commit('setLogoutStatus')
  context.commit('setSuccess', null)
  context.commit('setPaymentCustomCode', "")
  setTimeout(() => {
    if (vm) {
      vm.$router.push('/user/login')
    } else if (window.location.pathname !== '/') {
      window.location = '/user/login'
    } else {
      window.location = `${process.env.BASE_URL  }user/login`
    }
  }, 2000)

  if (signOutRequest) {
    try {
      await signOutRequest
    } catch (e) {
      console.log(e) // eslint-disable-line no-console
    }
  }
}

export async function otpReset (context, payload) {
  console.log('Reset Password...') // eslint-disable-line no-console

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
    newPassword: payload.form.newPassword
  }
  try {
    const response = await apolloClient
      .mutate({
        mutation: OTP_RESET,
        variables
      })

    const { data } = await response

    context.commit('setCurrentUser', data.otpReset)
    context.commit('setSuccess', serverResponseStatus('notification.otp-reset-success-title', {
      status: {success: true, error: false, message: 'notification.otp-reset-success-message'}
    }))

    setTimeout(() => {
      payload.vm.$router.push("/")
    }, 200);
  } catch (e) {
    console.log(e) // eslint-disable-line no-console
    context.commit('setError', error(null, null))
  }
}

export async function initUser (context, payload) {
  if (supportState.mode) return
  const token = localStorage.getItem('token')
  if (token) {
    try {
      // console.log('User data is initializing')
      context.commit('clearError')
      context.commit('setProcessing', true)
      const result = await apolloClient.query({
        query: GET_CURRENT_USER,
        fetchPolicy: 'network-only'
      })
      const { data } = result

      context.commit('setCurrentUser', data.getCurrentUser)
    } catch (e) {
      console.log(e) // eslint-disable-line no-console
      context.commit('setError', error(e))
    }
  }
}

export async function authenticationError (context) {
  if (supportState.mode) { endSupport(); return }
  console.log('Authentication Error...') // eslint-disable-line no-console

  context.commit('clearError')
  context.commit('setProcessing', true)

  context.commit('setLogoutStatus')
  context.commit('setSuccess', null)

  setTimeout(() => {
    if (window.location.pathname !== '/user/login') {
      window.location = '/user/login'
    }
  }, 1000)
}

export async function forgotPassword (context, payload) {
  //console.log('SignIn...') // eslint-disable-line no-console
  context.commit('clearError')
  context.commit('setProcessing', true)
  try {
    const variables = {...payload.credential}

    const response = await apolloClient
      .mutate({
        mutation: FORGOT_PASSWORD,
        variables,
        fetchPolicy: 'no-cache'
      })
      const {data} = await response

      // console.log(data)
      context.commit('setSuccess', null)
      return data.forgotPassword
  } catch (e) {
    console.log(e) // eslint-disable-line no-console
    context.commit('setError', null)
  }
}

export async function updateInformation(context, payload) {
  // console.log('Add QrPayment...')

  context.commit('clearError')
  context.commit('setProcessing', true)

  const variables = {
      email: payload.form.email,
      mobile: payload.form.mobile
  }
  try {
      const response = await apolloClient
          .mutate({
              mutation: UPDATE_INFORMATION,
              variables,
              fetchPolicy: 'no-cache'
          })
      const {data} = await response
      if(data.updateInformation.result){
        context.commit('setCurrentEmailAndMobile', variables)
        context.commit('setSuccess', addItemSuccess({}))
      }else{
        context.commit('setError', error(null, null))
      }
  } catch (e) {
      // console.log(e)
      context.commit('setError', error(null, null))
      return false
  }
}
